import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import autobind from 'autobind-decorator';
import { notice } from 'ducks/notifications';
import { invalidateRequests } from 'redux-bees';
import api from 'api';
import { connect } from 'react-redux';
import Switch from 'rc-switch';
import Tooltip from 'components/Tooltip';
import Spinner from 'components/Spinner';

@connect()

export default class WpSwitch extends Component {

  static propTypes = {
    showText: PropTypes.bool,
    site: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    addSteps: PropTypes.func,
    addLastTourSteps: PropTypes.func,
  }

  componentDidMount() {
    if (this.props.addSteps) {
      const steps = [
        {
          title: 'WordPress Switch',
          text: 'Use this switch to turn WordPress ON or OFF',
          selector: '.tour-wpswitch',
          position: 'top',
        },
      ];

      this.props.addSteps(steps);
      this.props.addLastTourSteps();
    }
  }

  @autobind
  handleChange(start) {
    const { dispatch, site } = this.props;

    if (start) {
      return dispatch(api.startSite({ id: site.id }, null))
      .catch(({ body }) => dispatch(notice(this.t(`error.${body.errors[0].code}`))));
    }

    return dispatch(api.stopSite({ id: site.id }, null))
    .then(() => {
      dispatch(invalidateRequests(api.getDeploys));
    })
    .catch(() => dispatch(notice('Error')));
  }

  render() {
    const { site, showText } = this.props;

    let tooltip = null;
    let label = null;
    let checked = false;
    let disabled = true;

    if (site.attributes.wpState === 'paused') {
      label = 'WordPress is paused';
      tooltip = 'Switch WordPress ON';
      disabled = false;
    }
    if (site.attributes.wpState === 'running') {
      label = 'WordPress is running';
      tooltip = 'Switch WordPress OFF';
      checked = true;
      disabled = false;
    }
    if (site.attributes.wpState === 'pausing') {
      label = 'Switching WordPress OFF...';
      checked = true;
    }
    if (site.attributes.wpState === 'loading') {
      label = 'Switching WordPress ON...';
    }
    if (site.attributes.wpState === 'deploying') {
      label = 'Publishing site...';
      checked = true;
    }

    return (
      <div className="WpSwitch">
        {
          showText &&
          <div className="WpSwitch__label">
            {
              disabled &&
                <Spinner inline size={20} />
            }
            {label}
          </div>
        }
        <Tooltip label={tooltip}>
          <Switch
            className="tour-wpswitch"
            checked={checked}
            disabled={disabled}
            onChange={this.handleChange}
          />
        </Tooltip>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/WpSwitch.jsx